import { AgenturNameCell } from 'app/components/shared/AgenturName.cell';
import { MonthRangePicker } from 'app/components/common/DatePickers';
import { Table } from 'app/components/table/table';
import { ITableColumn, TableModel } from 'app/components/table/table.model';
import { useStore } from 'app/context';
import { runInAction } from 'mobx';
import { observer } from 'mobx-react';
import { useEffect, useMemo, useState } from 'react';
import { KvmVM } from 'app/stores/ui/agt.kvm.ui.store';

export const KvmOptions = observer(() => {
	const { agtKvmUiStore } = useStore();

	const onMinChange = (value: number) => {
		runInAction(() => {
			agtKvmUiStore.minBmCurrent = value;
		});
	};

	const onMaxChange = (value: number) => {
		runInAction(() => {
			agtKvmUiStore.maxBmCurrent = value;
		});
	};

	return (
		<MonthRangePicker
			minValue={agtKvmUiStore.minBm}
			maxValue={agtKvmUiStore.maxBm}
			opts={agtKvmUiStore.bmsOpts}
			onMinChange={onMinChange}
			onMaxChange={onMaxChange}
			emptyTextMin="Start Monat"
			emptyTextMax="End Monat"
			queryParam="bm"
		/>
	);
});

export const KvmListe = observer(() => {
	const { berichteUiiStore, agtKvmUiStore, agenturListUiStore } = useStore();
	const [hasItems, setHasItems] = useState(false);

	const tm = useMemo(() => {
		const tm = new TableModel<KvmVM, number>();
		const cols: ITableColumn<KvmVM, number>[] = [];

		cols.push({
			label: 'Agentur',
			path: 'agt.name',
			sortBy: 'agt.name',
			render: AgenturNameCell,
		});
		cols.push({
			label: 'Anzahl BM',
			path: 'anzahlBm',
			sortBy: 'anzahlBm',
		});
		cols.push({
			label: 'Anrufe Gesamt',
			path: 'anzahlAnrufeGesamt',
			sortBy: 'anzahlAnrufeGesamt',
		});
		cols.push({
			label: 'Anrufe Servicezeiten',
			path: 'anzahlAnrufeWaehrendServicezeiten',
			sortBy: 'anzahlAnrufeWaehrendServicezeiten',
		});
		cols.push({
			label: 'Ziel 1 Schaden',
			path: 'ziel1Schaden',
			sortBy: 'ziel1Schaden',
		});
		cols.push({
			label: 'Ziel 2 Vertragsanliegen',
			path: 'ziel2Vertragsanliegen',
			sortBy: 'ziel2Vertragsanliegen',
		});
		cols.push({
			label: 'Ziel 3 Sonstige Anliegen',
			path: 'ziel3SonstigeAnliegen',
			sortBy: 'ziel3SonstigeAnliegen',
		});
		cols.push({
			label: 'Ziel 3 Dann Retoure',
			path: 'ziel3DannRetoure',
			sortBy: 'ziel3DannRetoure',
		});
		cols.push({
			label: 'Retoure',
			path: 'retoure',
			sortBy: 'retoure',
		});
		cols.push({
			label: 'Keine Taste',
			path: 'keineTaste',
			sortBy: 'keineTaste',
		});
		cols.push({
			label: 'Schnellaufleger',
			path: 'schnellauflege',
			sortBy: 'schnellauflege',
		});

		tm.sortBy = 'agt.name';
		tm.setCols(cols);

		tm.idProperty = 'agtId';
		tm.idType = 'number';

		return tm;
	}, []);

	useEffect(() => {
		agtKvmUiStore.load();
	}, [agtKvmUiStore]);

	useEffect(() => {
		if (!agtKvmUiStore.minBm || !agtKvmUiStore.maxBm) return;

		agtKvmUiStore.aggregateAgtsByBm(agtKvmUiStore.minBm, agtKvmUiStore.maxBm).then((res) => {
			let items = res;
			if (berichteUiiStore.selectedAgt) {
				const agtId = berichteUiiStore.selectedAgt.agtId;
				items = items.filter((i) => i.agt.agtId === agtId);
			} else {
				items = agenturListUiStore.applyFilterOnAgt(items) as KvmVM[];
			}
			setHasItems(items.length > 0);
			tm.setRowData(items);
			tm.sort();
		});
	}, [tm, berichteUiiStore.selectedAgt, agenturListUiStore.filterHasChanged, agenturListUiStore, agtKvmUiStore, agtKvmUiStore.maxBm, agtKvmUiStore.minBm]);

	return (
		<>
			<KvmOptions />
			<div className="table-container pad-bottom-3rem">
				{!hasItems ? (
					<div className="pad-1rem">Keine KVM Teilnahme</div>
				) : (
					<>
						<Table stickyHeader={true} tm={tm}></Table>
					</>
				)}
			</div>
		</>
	);
});
